
import './Programs.css';
import React, { Fragment } from "react"
import '../styles/global.css'


import heroImg from '../images/bb_classroom.JPEG'; 
import FadeInSection from '../components/fadeinsection.jsx';

import english from '../images/English.jpg';
import bengali from '../images/Bangla.jpg';
import math from '../images/bb_math.JPEG';
import science from '../images/bb_science.JPEG';
import globalstudies from '../images/bb_globalstudies.jpg';
import additional from '../images/Additional Activities.jpeg';

function Programs() {
  return (
    <Fragment>
      <div className="programs-hero"style={{ backgroundImage: `url(${heroImg})` }}>
        <div className="hero-overlay">
          <h1>Our Educational Programs</h1>
        </div>
      </div>

      <p className="mid-paragraph">
          Students are introduced to elementary level English, Bengali, Math, Global Studies and Science. We put emphasis on engaging students through fun and engaging activities. On Fridays we offer additional activities for students who are interested in religoin studies, arts & crafts and movies.
      </p>
      <section className="programs-container">
        

        <FadeInSection>
          <div id="english" className="program-row">
          <div className="program-text">
            <h2>English</h2>
            <p>
              Our English curriculum builds foundational reading, writing, and speaking skills. We focus on communication through stories, interactive activities, and visual learning to engage students at all levels.
            </p>
          </div>
          <div className="program-image">
            <img src={english} alt="English class" />
          </div>
        </div>
        </FadeInSection>
        

        <FadeInSection>
          <div id="bengali" className="program-row ">
            <div className="program-text">
              <h2>Bangla</h2>
              <p>
                Bangla language classes help students develop literacy in their native tongue. Emphasis is placed on reading comprehension, poetry, cultural stories, and creative writing to build pride in heritage.
              </p>
            </div>
            <div className="program-image">
              <img src={bengali} alt="Bengali class" />
            </div>
          </div>
        </FadeInSection>

        <FadeInSection>
          <div id="math" className="program-row">
            <div className="program-text">
              <h2>Math</h2>
              <p>
                Our math program focuses on basic arithmetic, logic puzzles, and hands-on activities to develop numerical literacy. We aim to make math fun, visual, and practical for everyday life.
              </p>
            </div>
            <div className="program-image">
              <img src={math} alt="Math class" />
            </div>
          </div>
        </FadeInSection>

        <FadeInSection>
          <div id="science" className="program-row ">
            <div className="program-text">
              <h2>Science</h2>
              <p>
                Students explore the world through science experiments, nature walks, and observation-based learning. Topics include biology, the environment, and physical sciences.
              </p>
            </div>
            <div className="program-image">
              <img src={science} alt="Science class" />
            </div>
          </div>
        </FadeInSection>

        <FadeInSection>
          <div id="globalstudies" className="program-row">
            <div className="program-text">
              <h2>Global Studies</h2>
              <p>
                Global Studies introduces students to world geography, cultures, and current events. Activities include map exploration and learning about diversity and cooperation.
              </p>
            </div>
            <div className="program-image">
              <img src={globalstudies} alt="Global Studies class" />
            </div>
          </div>
        </FadeInSection>

        <FadeInSection>
          <div id="additionalactivities" className="program-row ">
            <div className="program-text">
              <h2>Additional Activities</h2>
              <p>
                On Fridays we offer additional activities for students who are interested in religion studies, arts and crafts, and movies.
              </p>
            </div>
            <div className="program-image">
              <img src={additional} alt="Extra-curricular activities" />
            </div>
          </div>
        </FadeInSection>
      </section>
    </Fragment>
    
  );
}

export default Programs;